module.exports = __webpack_public_path__ + "static/media/about_part2.3220f2a3.png";